import React from 'react';
import cn from 'classnames';
import { useLocation } from '@reach/router';
import LazyImage from 'components/UI/LazyImage';
import Icon from 'components/UI/Icon';
import Title from 'components/UI/Title';
import Markup from 'components/Markup';
import List from 'components/UI/List';
import Link from 'components/UI/Link';
import { replaceKeyword } from 'utils';
import { useTrans } from 'utils/localisation';

import * as styles from './Card.module.scss';

export default function Card({
  className,
  icon,
  imgSrc,
  title,
  titleTag = 'h3',
  titleLabel,
  subtitle,
  description,
  secondDescription,
  list,
  secondList,
  link,
  linkTitle,
  isLinkForWrapper = false,
  theme,
}) {
  const currentLink = useLocation().pathname;
  const preparedLink = currentLink !== link ? link : null;

  const Wrapper = isLinkForWrapper && preparedLink ? Link : 'div';
  const listItemTag = titleTag === 'h3' ? 'h4' : null;
  const t = useTrans(['common']);

  return (
    <Wrapper
      className={cn(className, styles.item, theme && styles[theme])}
      href={isLinkForWrapper && preparedLink ? preparedLink : null}
    >
      {imgSrc && <LazyImage src={imgSrc} alt={title} className={styles.img} />}
      {icon && <Icon name={icon} className={styles.icon} />}
      {title && (
        <Title tag={titleTag} size="h4" className={styles.title}>
          {replaceKeyword(title)}
        </Title>
      )}
      {titleLabel && <p className={styles.titleLabel}>{replaceKeyword(titleLabel)}</p>}
      {subtitle && (
        <Markup tag="p" className={styles.description}>
          {replaceKeyword(subtitle)}
        </Markup>
      )}
      {description && (
        <Markup tag="p" className={styles.description}>
          {replaceKeyword(description)}
        </Markup>
      )}
      {list && (
        <List
          items={list}
          className={styles.list}
          theme="smallMarginChecked"
          itemTag={listItemTag}
        />
      )}
      {secondDescription && (
        <p className={styles.description}>{replaceKeyword(secondDescription)}</p>
      )}
      {secondList && (
        <List
          items={secondList}
          className={styles.list}
          theme="smallMarginChecked"
          itemTag={listItemTag}
        />
      )}
      {preparedLink && (
        <div className={styles.linkRow}>
          {isLinkForWrapper ? (
            <div className={styles.link}>{linkTitle ?? t('seeMore')}</div>
          ) : (
            <Link className={styles.link} href={preparedLink}>
              {linkTitle ?? t('seeMore')}
            </Link>
          )}
        </div>
      )}
    </Wrapper>
  );
}
